export interface CopilotPromptInsertRequest {
  insertText: string;
  emptyPromptText?: string;
  focus?: boolean;
}

const COPILOT_PROMPT_INSERT_EVENT_NAME = 'copilot:insert-prompt-text';

export const dispatchCopilotPromptInsert = (request: CopilotPromptInsertRequest): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<CopilotPromptInsertRequest>(COPILOT_PROMPT_INSERT_EVENT_NAME, {
      detail: request,
    })
  );
};

export const addCopilotPromptInsertListener = (
  listener: (request: CopilotPromptInsertRequest) => void
): (() => void) => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const handlePromptInsert = (event: Event): void => {
    const request = (event as CustomEvent<CopilotPromptInsertRequest>).detail;
    if (!request?.insertText && !request?.emptyPromptText) {
      return;
    }

    listener(request);
  };

  window.addEventListener(COPILOT_PROMPT_INSERT_EVENT_NAME, handlePromptInsert);

  return (): void => {
    window.removeEventListener(COPILOT_PROMPT_INSERT_EVENT_NAME, handlePromptInsert);
  };
};
